import React, { useEffect, useState } from "react";
import "./Contact.css";
import { useAppContext } from "../../contexts/AppContext";
import axios from "axios";
import ContacForm from "./ContactForm";
import parse from "html-react-parser";

function Contacts() {
  const { backendUrl, translate } = useAppContext();
  const [contactBody, setContactBody] = useState([]);
  const [phoneList, setPhoneList] = useState([]);
  const [emailList, setEmailList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const callUsRoute = "/CallUs";
  const emailRoute = "/Email";
  const contactBodyRoute = "/ContactBody";
  const locationRoute = "/Adress";

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const contactBodyRes = await axios.get(`${backendUrl}${contactBodyRoute}`);
        const emailRes = await axios.get(`${backendUrl}${emailRoute}`);
        const phoneRes = await axios.get(`${backendUrl}${callUsRoute}`);
        const locationRes = await axios.get(`${backendUrl}${locationRoute}`);

        if (Array.isArray(contactBodyRes?.data)) setContactBody(contactBodyRes?.data);
        if (Array.isArray(emailRes?.data)) setEmailList(emailRes?.data);
        if (Array.isArray(phoneRes?.data)) setPhoneList(phoneRes?.data);
        if (Array.isArray(locationRes?.data)) {
          setLocationList(locationRes?.data);
          setSelectedLocation(locationRes?.data[0]);
        }
      } catch (error) {
        console.error("Error fetching contact information:", error);
      }
    };
    fetchContactInfo();
  }, [backendUrl]);

  return (
    <div>
      {(Array.isArray(contactBody) && (contactBody.length > 0 ||
        phoneList.length > 0 ||
        emailList.length > 0 ||
        locationList.length > 0)) && (
          <div className="contact-container animated">
            {/* Contact Title and Content */}
            {contactBody.map((contactBodys, index) => (
              <div key={index} className="contact-title-container">
                <div className="service-title-container">
                  <div>
                    {contactBodys?.title && (
                      <h1>{parse(translate(contactBodys?.title))}</h1>
                    )}
                  </div>
                  <div className="title-underlined"></div>
                </div>
                <div>
                  {contactBodys?.content && (
                    <p style={{ fontWeight: "400" }}>
                      {parse(translate(contactBodys?.content))}
                    </p>
                  )}
                </div>
              </div>
            ))}

            {/* Address Section */}
            <div className="adress-container border border-1">
              <div className="adress-information-container">
                {/* Call Us Section */}
                <div className="adress-phone-container">
                  <div className="adress-phone-number">
                    <div className="d-flex w-100 align-items-center">
                      {phoneList.length > 0 && (
                        <span>
                          <h3 style={{ lineHeight: "0.4rem" }}>
                            <span className="bi bi-telephone mx-2 fw-bolder"></span>
                            {parse(translate("mobile"))}
                          </h3>
                        </span>
                      )}
                    </div>
                    {phoneList.map((phoneItem, index) => (
                      <div className="d-flex align-items-center" key={index}>
                        <p
                          className="nav-link ms-4 d-flex flex-wrap align-items-center"
                          onClick={() => (window.location.href = `tel:${phoneItem.mobile}`)}
                          style={{ cursor: "pointer" }}
                        >
                          <span className="fw-light">{phoneItem?.mobile}</span>
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Email Us Section */}
                <div className="adress-phone-container">
                  <div className="adress-phone-number">
                    <div className="d-flex w-100 align-items-center">
                      {emailList.length > 0 && (
                        <span>
                          <h3>
                            <span className="bi bi-envelope mx-2 fw-bolder"></span>
                            {parse(translate("Email"))}
                          </h3>
                        </span>
                      )}
                    </div>
                    {emailList.map((emailItem, index) => (
                      <div className="d-flex align-items-center" key={index}>
                        <p
                          className="nav-link ms-4 d-flex flex-wrap"
                          onClick={() => (window.location.href = `mailto:${emailItem.email}`)}
                          style={{ cursor: "pointer" }}
                        >
                          <span className="fw-light">{emailItem?.email}</span>
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Locations Section */}
                <div className="adress-phone-container">
                  <div className="adress-phone-number">
                    <div className="d-flex w-100 align-items-center">
                      {locationList.length > 0 && (
                        <span>
                          <h3>
                            <span className="bi bi-geo mx-2 fw-light"></span>
                            {parse(translate("Our location"))}
                          </h3>
                        </span>
                      )}
                    </div>
                    {locationList.map((locationItem, index) => (
                      <div key={index} className="d-flex align-items-center">
                        <p
                          className="nav-link ms-4"
                          style={{ cursor: "pointer", marginRight: "10px" }}
                          onClick={() => setSelectedLocation(locationItem)}
                        >
                          <span className="fw-light">
                            {parse(translate(locationItem.location))}
                          </span>
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Map Section */}
              <div className="map-container">
                {selectedLocation && (
                  <iframe
                    className="map-item"
                    title={selectedLocation?.location}
                    loading="lazy"
                    src={selectedLocation?.link}
                    referrerPolicy="no-referrer-when-downgrade"
                    style={{ border: 0 }}
                  />
                )}
              </div>

              {/* Contact Form Section */}
              <div className="contact-form-container">
                <ContacForm />
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

export default Contacts;
